import { createSlice } from '@reduxjs/toolkit';
import { REDUX_ASYNC_STATUSES } from '../../consts/consts';

const { IDLE, LOADING, SUCCEEDED, FAILED } = REDUX_ASYNC_STATUSES;

const initialState = {
  worklistRisks: [],
  worklistRisksStatus: IDLE,

  worklistRiskMessages: null,
  worklistRiskMessagesStatus: IDLE,

  worklistRiskUnreadSinceDate: null,
  worklistRiskUnreadSinceDateStatus: IDLE,

  deleteWorklistRiskUnreadSinceStatus: IDLE,

  createWorklistRiskMessageStatus: IDLE,

  createWorklistRiskMessageAndConnectedActionsStatus: IDLE,

  updateWorklistRiskMessageStatus: IDLE,

  messageRecipientOrganizations: [],
  messageRecipientOrganizationsStatus: IDLE,

  isCreateMessageTouched: false,
  newMessageAttachments: [],
  isNewMessageAttachmentsUploadLoading: false,

  worklistRiskReplyRecipientId: null,

  worklistRiskRecommendations: null,
  worklistRiskRecommendationsStatus: IDLE,

  worklistRiskReminders: [],
  worklistRiskRemindersStatus: IDLE,

  createWorklistRiskReminderStatus: IDLE,

  updateWorklistRiskReminderStatus: IDLE,

  deleteWorklistRiskReminderStatus: IDLE
};

const worklistRisksSlice = createSlice({
  name: 'worklistRisks',
  initialState,
  reducers: {
    getWorklistRisks(state) {
      state.worklistRisksStatus = LOADING;
    },
    getWorklistRisksSucceeded(state, action) {
      state.worklistRisks = action.payload;
      state.worklistRisksStatus = SUCCEEDED;
    },
    getWorklistRisksFailed(state) {
      state.worklistRisksStatus = FAILED;
    },

    getWorklistRiskMessages(state) {
      state.worklistRiskMessagesStatus = LOADING;
    },
    getWorklistRiskMessagesSucceeded(state, action) {
      state.worklistRiskMessages = action.payload;
      state.worklistRiskMessagesStatus = SUCCEEDED;
    },
    getWorklistRiskMessagesFailed(state) {
      state.worklistRiskMessagesStatus = FAILED;
    },
    clearWorklistRiskMessages(state) {
      state.worklistRiskMessages = null;
      state.worklistRiskMessagesStatus = IDLE;
    },

    getWorklistRiskUnreadSince(state) {
      state.worklistRiskUnreadSinceDateStatus = LOADING;
    },
    getWorklistRiskUnreadSinceSucceeded(state, action) {
      state.worklistRiskUnreadSinceDate = action.payload;
      state.worklistRiskUnreadSinceDateStatus = SUCCEEDED;
    },
    getWorklistRiskUnreadSinceFailed(state) {
      state.worklistRiskUnreadSinceDateStatus = FAILED;
    },

    deleteWorklistRiskUnreadSince(state) {
      state.deleteWorklistRiskUnreadSinceStatus = LOADING;
    },
    deleteWorklistRiskUnreadSinceSucceeded(state) {
      state.deleteWorklistRiskUnreadSinceStatus = SUCCEEDED;
    },
    deleteWorklistRiskUnreadSinceFailed(state) {
      state.deleteWorklistRiskUnreadSinceStatus = FAILED;
    },

    createWorklistRiskMessage(state) {
      state.createWorklistRiskMessageStatus = LOADING;
    },
    createWorklistRiskMessageSucceeded(state) {
      state.createWorklistRiskMessageStatus = SUCCEEDED;
    },
    createWorklistRiskMessageFailed(state) {
      state.createWorklistRiskMessageStatus = FAILED;
    },

    createWorklistRiskMessageAndConnectedActions(state) {
      state.createWorklistRiskMessageAndConnectedActionsStatus = LOADING;
    },
    createWorklistRiskMessageAndConnectedActionsSucceeded(state) {
      state.createWorklistRiskMessageAndConnectedActionsStatus = SUCCEEDED;
    },
    createWorklistRiskMessageAndConnectedActionsFailed(state) {
      state.createWorklistRiskMessageAndConnectedActionsStatus = FAILED;
    },

    updateWorklistRiskMessage(state) {
      state.updateWorklistRiskMessageStatus = LOADING;
    },
    updateWorklistRiskMessageSucceeded(state) {
      state.updateWorklistRiskMessageStatus = SUCCEEDED;
    },
    updateWorklistRiskMessageFailed(state) {
      state.updateWorklistRiskMessageStatus = FAILED;
    },

    getRiskMessageRecipientOrganizations(state) {
      state.messageRecipientOrganizationsStatus = LOADING;
    },
    getRiskMessageRecipientOrganizationsSucceeded(state, action) {
      state.messageRecipientOrganizations = action.payload;
      state.messageRecipientOrganizationsStatus = SUCCEEDED;
    },
    getRiskMessageRecipientOrganizationsFailed(state) {
      state.messageRecipientOrganizationsStatus = FAILED;
    },

    setIsCreateMessageTouched(state, action) {
      state.isCreateMessageTouched = action.payload;
    },
    clearIsCreateMessageTouched(state) {
      state.isCreateMessageTouched = false;
    },

    setWorklistRiskNewMessageAttachments(state, action) {
      state.newMessageAttachments = action.payload;
    },
    clearWorklistRiskNewMessageAttachments(state) {
      state.newMessageAttachments = [];
    },
    setWorklistRiskNewMessageAttachmentsUploadLoading(state, action) {
      state.isNewMessageAttachmentsUploadLoading = action.payload;
    },

    setWorklistRiskReplyRecipientId(state, action) {
      state.worklistRiskReplyRecipientId = action.payload;
    },
    clearWorklistRiskReplyRecipientId(state) {
      state.worklistRiskReplyRecipientId = null;
    },

    getWorklistRiskRecommendations(state) {
      state.worklistRiskRecommendationsStatus = LOADING;
    },
    getWorklistRiskRecommendationsSucceeded(state, action) {
      state.worklistRiskRecommendations = action.payload;
      state.worklistRiskRecommendationsStatus = SUCCEEDED;
    },
    getWorklistRiskRecommendationsFailed(state) {
      state.worklistRiskRecommendationsStatus = FAILED;
    },
    clearWorklistRiskRecommendations(state) {
      state.worklistRiskRecommendations = null;
      state.worklistRiskRecommendationsStatus = IDLE;
    },

    getWorklistRiskReminders(state) {
      state.worklistRiskRemindersStatus = LOADING;
    },
    getWorklistRiskRemindersSucceeded(state, action) {
      state.worklistRiskReminders = action.payload;
      state.worklistRiskRemindersStatus = SUCCEEDED;
    },
    getWorklistRiskRemindersFailed(state) {
      state.worklistRiskRemindersStatus = FAILED;
    },

    createWorklistRiskReminder(state) {
      state.createWorklistRiskReminderStatus = LOADING;
    },
    createWorklistRiskReminderSucceeded(state) {
      state.createWorklistRiskReminderStatus = SUCCEEDED;
    },
    createWorklistRiskReminderFailed(state) {
      state.createWorklistRiskReminderStatus = FAILED;
    },

    updateWorklistRiskReminder(state) {
      state.updateWorklistRiskReminderStatus = LOADING;
    },
    updateWorklistRiskReminderSucceeded(state) {
      state.updateWorklistRiskReminderStatus = SUCCEEDED;
    },
    updateWorklistRiskReminderFailed(state) {
      state.updateWorklistRiskReminderStatus = FAILED;
    },

    deleteWorklistRiskReminder(state) {
      state.deleteWorklistRiskReminderStatus = LOADING;
    },
    deleteWorklistRiskReminderSucceeded(state) {
      state.deleteWorklistRiskReminderStatus = SUCCEEDED;
    },
    deleteWorklistRiskReminderFailed(state) {
      state.deleteWorklistRiskReminderStatus = FAILED;
    }
  }
});

export const {
  getWorklistRisks,
  getWorklistRisksSucceeded,
  clearWorklistRiskMessages,
  getWorklistRisksFailed,
  getWorklistRiskMessages,
  getWorklistRiskMessagesSucceeded,
  getWorklistRiskMessagesFailed,
  getWorklistRiskUnreadSince,
  getWorklistRiskUnreadSinceSucceeded,
  getWorklistRiskUnreadSinceFailed,
  deleteWorklistRiskUnreadSince,
  deleteWorklistRiskUnreadSinceSucceeded,
  deleteWorklistRiskUnreadSinceFailed,
  createWorklistRiskMessage,
  createWorklistRiskMessageSucceeded,
  createWorklistRiskMessageFailed,
  createWorklistRiskMessageAndConnectedActions,
  createWorklistRiskMessageAndConnectedActionsSucceeded,
  createWorklistRiskMessageAndConnectedActionsFailed,
  updateWorklistRiskMessage,
  updateWorklistRiskMessageSucceeded,
  updateWorklistRiskMessageFailed,
  getRiskMessageRecipientOrganizations,
  getRiskMessageRecipientOrganizationsSucceeded,
  getRiskMessageRecipientOrganizationsFailed,
  setIsCreateMessageTouched,
  clearIsCreateMessageTouched,
  setWorklistRiskNewMessageAttachments,
  clearWorklistRiskNewMessageAttachments,
  setWorklistRiskNewMessageAttachmentsUploadLoading,
  setWorklistRiskReplyRecipientId,
  clearWorklistRiskReplyRecipientId,
  getWorklistRiskRecommendations,
  getWorklistRiskRecommendationsSucceeded,
  getWorklistRiskRecommendationsFailed,
  clearWorklistRiskRecommendations,
  getWorklistRiskReminders,
  getWorklistRiskRemindersSucceeded,
  getWorklistRiskRemindersFailed,
  createWorklistRiskReminder,
  createWorklistRiskReminderSucceeded,
  createWorklistRiskReminderFailed,
  updateWorklistRiskReminder,
  updateWorklistRiskReminderSucceeded,
  updateWorklistRiskReminderFailed,
  deleteWorklistRiskReminder,
  deleteWorklistRiskReminderSucceeded,
  deleteWorklistRiskReminderFailed
} = worklistRisksSlice.actions;

export default worklistRisksSlice.reducer;
